module.exports = __webpack_public_path__ + "static/media/delete.801c9c7a.svg";